import React from 'react'
import styled from 'styled-components'

// components
import Grid from '@material-ui/core/Grid'
import { H3 } from 'components/typography/H3';

// styled components
const IndustryWrapper = styled(Grid)`
  margin-top: 40px;
`; 

const Item = styled(Grid)`
  padding: 10px !important;
  margin-bottom: 10px !important;
  cursor: pointer;
  transition: all .25s;

  & b {
    transition: all 0.25s;
  }

  &:hover {
    background-color: #616161;

    img {
      filter: brightness(100);
    }

    b {
      color: white;
    }
  }
`; 

const Img = styled.img`
  height: 70px;
  width: auto;
  margin-bottom: 8px;
`; 

const Note = styled.div`
  background-color: ${({theme}) => theme.DARK_BLUE};
  color: white;
  margin: 0 7%;
  padding: 10px 8px;

  a {
    text-decoration: underline;
    color: white;
  }
`;


// functions and properties
const industries = [
  { name: 'Hotel', img: 'hotel.png' },
  { name: 'Multi-Family', img: 'apartment.svg' },
  { name: 'Condominiums', img: 'miniums.svg' },
  { name: 'Gas Station', img: 'gas.svg' },
  { name: 'Assisted Living', img: 'assisted.svg' },
  { name: 'Restaurant', img: 'restaurant.svg' },
  { name: 'Office Space', img: 'office.svg' },
  { name: 'Single-Family', img: 'single-family.svg' },
  { name: 'Manufacturing', img: 'manufacturing.svg' },
]

const IndustrySelector = ({ onSelect }) => {

  return (
    <div align="center">
      <H3>Select the Industry that Best Fits Your Project</H3>
      <IndustryWrapper container justify="space-around">
        {
          industries.map((item, i) => (
            <Item key={i} item xs={4} alt={ item.name } onClick={() => onSelect(item)}>
              <Img src={require(`assets/images/${item.img}`).default} />
              <div>
                <b>{ item.name }</b>
              </div>
            </Item>
          ))
        }
        <Note>
          If your project does not fit into one of these 
          industries, please <a href="https://go.oncehub.com/JeremyShackle3" target="_blank">click here to schedule a call</a>
        </Note>
      </IndustryWrapper>
    </div>
  )
}

export default IndustrySelector;
